import {
  CaretDownFilled,
  CaretUpFilled,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { Content } from "antd/es/layout/layout";
import axios from "axios";
import FileSaver from "file-saver";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { APPCONFIG } from "../../../../Config";
import {
  ACCESS_TOKEN,
  DATA_MASTER_DATA_TYPE,
  INDUSTRY,
  INDUSTRY_TYPE,
  REGION_GROUP,
  WORK_PERIOD,
} from "../../../../lib/const";
import useLineOfWork from "../../../../lib/hooks/useLineOfWork";
import useCountry from "../../../../lib/hooks/useCountry";
import useMasterData from "../../../../lib/hooks/useMasterData";
import useEState from "../../../../lib/hooks/useEState";
import { routes } from "../../../../routes";
import APIEndpoint from "../../../../services/endpoint";
import {
  SearchCustomerPersonaContext,
  initialPageValues,
  initialSearchValues,
} from "../searchContext";
import { getListFactory } from "../../../../services/customerCurrent";
import { jsPDF} from "jspdf";
import html2canvas from "html2canvas";


const { Title } = Typography;
const { Option } = Select;
const years = moment().add(1, "years").format("YYYY");
const yearArray = [
  parseInt(years),
  parseInt(years - 1),
  parseInt(years - 2),
  parseInt(years - 3),
  parseInt(years - 4),
];
const months = [
  {
    value: 1,
    name: "ตุลาคม",
  },
  {
    value: 2,
    name: "พฤศจิกายน",
  },
  {
    value: 3,
    name: "ธันวาคม",
  },
  {
    value: 4,
    name: "มกราคม",
  },
  {
    value: 5,
    name: "กุมภาพันธ์",
  },
  {
    value: 6,
    name: "มีนาคม",
  },
  {
    value: 7,
    name: "เมษายน",
  },
  {
    value: 8,
    name: "พฤษภาคม",
  },
  {
    value: 9,
    name: "มิถุนายน",
  },
  {
    value: 10,
    name: "กรกฎาคม",
  },
  {
    value: 11,
    name: "สิงหาคม",
  },
  {
    value: 12,
    name: "กันยายน",
  },
];

const Search = ({ roleUser }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [countries, optionCountries] = useCountry();
  const [lineOfWork] = useLineOfWork();
  const [estates, estateList] = useEState();
  const [regionGroup] = useMasterData(DATA_MASTER_DATA_TYPE, REGION_GROUP);
  const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);
  const [industryType] = useMasterData(DATA_MASTER_DATA_TYPE, INDUSTRY_TYPE);
  let [industries] = useMasterData("", INDUSTRY);
  const [estateId, setEstateId] = useState("");
  const [factoryAutocomplete, setFactorAutocomplete] = useState([]);

  let [filteredIndustries, setFilteredIndustries] = useState([]);

  const {
    setPageValues,
    setSearch,
    searchValues,
    pageValues,
    setSearchValues,
  } = useContext(SearchCustomerPersonaContext);
  const [searchCollapse, setSearchCollapse] = useState(false);

  const [waterConsumption, setWaterConsumption] = useState({
    min: 0,
    max: 0,
  });
  const [areaSize, setAreaSize] = useState({
    raiMin: 0,
    raiMax: 0,
    waMin: 0,
    waMax: 0,
    nganMin: 0,
    nganMax: 0,
  });
  const [areaSizeByMeter, setAreaSizeByMeter] = useState({
    min: 0,
    max: 0,
  });

  const options = [];
  for (let i = 10; i < 15; i++) {
    options.push({
      value: i.toString(15) + i,
      label: i.toString(15) + i,
    });
  }

  const handleCollape = () => {
    setSearchCollapse(!searchCollapse);
  };

  const handleClearSearchForm = () => {
    form.resetFields();
    setWaterConsumption({
      min: 0,
      max: 0,
    });
    setAreaSize({
      raiMin: 0,
      raiMax: 0,
      waMin: 0,
      waMax: 0,
      nganMin: 0,
      nganMax: 0,
    });
    setAreaSizeByMeter({
      min: 0,
      max: 0,
    });
    setEstateId("");
    setSearchValues(initialSearchValues);
    setPageValues(initialPageValues);
    setSearch(true);
  };

  const getListFactoryAutocomplete = async (searchText) => {
    const res = await getListFactory(searchText);
    const { objectValue } = res.data;

    if (res?.data?.code === "0000") {
      const mapValue = objectValue.map((data, index) => {
        return {
          ...data,
          value: _.get(data, "factoryNameTh") || _.get(data, "factoryNameEn"),
          id: index,
          key: index,
        };
      });

      setFactorAutocomplete(mapValue);
    } else {
      setFactorAutocomplete([]);
    }
  };

  const onSearch = (values) => {
    setSearch(true);

    let typeOfEstates = [];
    if (values?.typeOfEstate && values?.typeOfEstate.includes("all")) {
      industries.map((item) => typeOfEstates.push(item.industryId));
    } else {
      typeOfEstates = values?.typeOfEstate;
    }

    let customerGroupByEstateTypes = [];
    if (
      values?.customerGroupByEstateType &&
      values?.customerGroupByEstateType.includes("all")
    ) {
      industryType.map((item) => customerGroupByEstateTypes.push(item.dataId));
    } else {
      customerGroupByEstateTypes = values?.customerGroupByEstateType;
    }

    let yearOfBudgets = [];
    if (values?.yearOfBudget && values?.yearOfBudget.includes("all")) {
      yearOfBudgets = yearArray;
    } else {
      yearOfBudgets = values?.yearOfBudget;
    }

    let monthOfBudgets = [];
    if (values?.monthOfBudget && values?.monthOfBudget.includes("all")) {
      // for (let i = 0; i < months.length; i++) {
      //   monthOfBudgets.push(months[i].value);
      // }
      months.map((m) => monthOfBudgets.push(m.value));
    } else {
      monthOfBudgets = values?.monthOfBudget;
    }

    let customerGroupByAges = [];
    if (
      values?.customerGroupByAge &&
      values?.customerGroupByAge.includes("all")
    ) {
      workPeriod.map((item) => customerGroupByAges.push(item.dataId));
    } else {
      customerGroupByAges = values?.customerGroupByAge;
    }

    let customerGroupByRegions = [];
    if (
      values?.customerGroupByRegion &&
      values?.customerGroupByRegion.includes("all")
    ) {
      regionGroup.map((item) => customerGroupByRegions.push(item.dataId));
    } else {
      customerGroupByRegions = values?.customerGroupByRegion;
    }

    let lineOfWorks = [];
    if (values?.lineOfWork && values?.lineOfWork.includes("all")) {
      lineOfWork.map((item) => lineOfWorks.push(item.lineOfWork));
    } else {
      lineOfWorks = values?.lineOfWork;
    }

    setSearchValues({
      currentCustomerId: "",
      factoryName: values?.factoryName,
      typeOfEstate: typeOfEstates, //[]
      customerGroupByEstateType: customerGroupByEstateTypes, //[]
      yearOfBudget: yearOfBudgets, //[]
      monthOfBudget: monthOfBudgets, //[]
      customerGroupByAge: customerGroupByAges, //[]
      customerGroupByRegion: customerGroupByRegions, //[]
      waterConsumptionMin: waterConsumption.min || "",
      waterConsumptionMax: waterConsumption.max || "",
      areaSizeByRaiMin: areaSize.raiMin || "",
      areaSizeByRaiMax: areaSize.raiMax || "",
      areaSizeByNganMin: areaSize.nganMin || "",
      areaSizeByNganMax: areaSize.nganMax || "",
      areaSizeByWaMin: areaSize.waMin || "",
      areaSizeByWaMax: areaSize.waMax || "",
      areaSizeByMetersMin: areaSizeByMeter.min || "",
      areaSizeByMetersMax: areaSizeByMeter.max || "",
      buyOrRentLand: values?.buyOrRentLand || "",
      productAndServiceWant: "",
      supportWant: "",
      transactionWant: "",
      crmExpected: "",
      lineOfWorkId: lineOfWorks, //[]
      countryId: values?.countryId || [],
      estateId: estateId,
    });
  };
  const onExportPDF = async (fileName) =>{
    const input = document.getElementById("LIST_CUSTOMER");
    html2canvas(input)
    .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({orientation: 'landscape'});
        const imgProps= pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(fileName);
        // pdf.addImage(imgData, 'JPEG', 0, 0);
        // pdf.save(fileName);
    });
    
  };
  const onExportPDF2 = async (fileName) => {
    const input = document.getElementById("LIST_CUSTOMER2");
    const canvas = await html2canvas(input, { useCORS: true });
  
    const imgData = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF({ orientation: 'landscape' });
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
  
    // 🔽 ย่อภาพให้พอดี 1 หน้า PDF
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  
    pdf.save(fileName);
  };
  

  useEffect(() => {}, [form]);

  const onCustomerGroupByEstateType = () => {
    let arr = form.getFieldValue().customerGroupByEstateType;

    // all, ไม่สามารถระบุได้
    if (
      !arr.includes("all") &&
      !arr.includes("38822bf4-3411-11ee-b359-005056014b8c")
    ) {
      if (
        // basic : ทั่วไป
        arr.includes("ff3b7ae8-d200-4ff2-96bb-85720f1ae4e4") &&
        !arr.includes("02915df5-f9d1-4193-a251-396897c5b4d1")
      ) {
        let newObj = industries.filter((item) => item.isBasicIndustry);
        setFilteredIndustries(newObj);
      } else {
        // s-curve
        let newObj = industries.filter((item) => item.isSCurve);
        setFilteredIndustries(newObj);
      }
    } else {
      setFilteredIndustries([]);
    }
  };

  const onSelectEstateId = (value, option) => {
    setEstateId(option.estateId);
  };

  const onChangeEstateId = (value) => {
    if (value === "") {
      setEstateId("");
    }
  };

  useEffect(() => {
    getListFactoryAutocomplete("");
  }, []);

  return (
    <Content>
      <Form style={{ marginBottom: 20 }}>
      <Row gutter={[24, 24]}>
            <Col span={24}>
              <div className="flex justify-between items-center">
                <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                 Customer Persona
                </Title>
                <div>
                  <Space>
                    {(roleUser[0]?.isAll || roleUser[0]?.isExport) && (
                      <>
                        <Button
                          onClick={() => onExportPDF("CustomerPersona.pdf")}
                        >
                          <UploadOutlined /> Export PDF
                        </Button>
                        <Button
                        onClick={() => onExportPDF2("Customer15Question.pdf")}
                        >
                          <UploadOutlined /> Export 15Q PDF
                        </Button>
                      </>
                    )}
                    {/* {(roleUser[0]?.isAll || roleUser[0]?.isCreate) && (
                      <Button
                        type="primary"
                        onClick={() => navigate(routes.add_customer_current)}
                      >
                        <PlusOutlined /> เพิ่มข้อมูล
                      </Button>
                    )} */}
                  </Space>
                </div>
              </div>
            </Col>
          </Row>
      </Form>
      <Form
        layout={"vertical"}
        form={form}
        style={{
          padding: 20,
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #F2F2F2",
          boxShadow: `0px 1px 10px 0px rgba(226, 216, 246, 0.40)`,
        }}
        onFinish={(value) =>
          onSearch({
            ...value,
            estateId: estateId ? estateId : undefined,
          })
        }
      >
        <Row gutter={[24, 16]}>
          <Col className="gutter-row" span={8}>
            <Form.Item name="factoryName">
              <AutoComplete
                filterOption={true}
                options={factoryAutocomplete}
                onSearch={(text) => getListFactoryAutocomplete(text)}
              >
                <Input placeholder="ชื่อบริษัท" prefix={<SearchOutlined />} />
              </AutoComplete>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name={"customerGroupByEstateType"}>
              <Select
                allowClear
                placeholder="กลุ่มลูกค้าตามกลุ่มอุตสาหกรรม"
                style={{
                  width: "100%",
                }}
                mode={"multiple"}
                maxTagCount={"responsive"}
                onChange={onCustomerGroupByEstateType}
              >
                <Option key={"all"} value={"all"}>
                  เลือกทั้งหมด
                </Option>
                {industryType.map((item) => (
                  <Option key={item.dataId} value={item.dataId}>
                    {item.dataDetailTh}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name={"typeOfEstate"}>
              <Select
                allowClear
                placeholder="ประเภทอุตสาหกรรม"
                style={{
                  width: "100%",
                }}
                mode={"multiple"}
                maxTagCount={"responsive"}
              >
                <Option key={"all"} value={"all"}>
                  เลือกทั้งหมด
                </Option>
                {filteredIndustries?.length > 0
                  ? filteredIndustries.map((item) => (
                      <Option key={item.industryId} value={item.industryId}>
                        {item.industryNameTh}
                      </Option>
                    ))
                  : industries.map((item) => (
                      <Option key={item.industryId} value={item.industryId}>
                        {item.industryNameTh}
                      </Option>
                    ))}
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name="estateId">
              <AutoComplete
                filterOption={true}
                options={estateList}
                onChange={(e) => onChangeEstateId(e)}
                onSelect={onSelectEstateId}
              >
                <Input
                  placeholder="ชื่อนิคมอุตสาหกรรม"
                  prefix={<SearchOutlined />}
                />
              </AutoComplete>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name={"buyOrRentLand"}>
              <Select
                // allowClear
                style={{
                  width: "100%",
                }}
                placeholder="ข้อมูลความต้องการขยายการลงทุน"
              >
                <Option value={"1"}>มี</Option>
                <Option value={"0"}>ไม่มี</Option>
                <Option value={""}>ไม่ทราบ</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name="countryId">
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="สัญชาติลูกค้า"
                style={{
                  width: "100%",
                }}
                mode={"multiple"}
                maxTagCount={"responsive"}
                options={optionCountries}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name={"yearOfBudget"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="ปีงบประมาณ"
                mode={"multiple"}
                maxTagCount={"responsive"}
              >
                <Option key={"all"} value={"all"}>
                  เลือกทั้งหมด
                </Option>
                {yearArray.map((item) => (
                  <Option value={parseInt(item)}>{parseInt(item) + 543}</Option>
                ))}
                {/* {(() => {
                  let arr = [];
                  for (let i = 0; i < 5; i++) {
                    arr.push(
                      <Option value={parseInt(years - i)}>
                        {parseInt(years) + 543 - i}
                      </Option>
                    );
                  }
                  console.log("arr ::", arr);
                  return arr;
                })()} */}
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name={"monthOfBudget"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="เดือน"
                mode={"multiple"}
                maxTagCount={"responsive"}
              >
                <Option key={"all"} value={"all"}>
                  เลือกทั้งหมด
                </Option>
                {months.map((m) => (
                  <Option value={m.value}>
                    เดือน {m.value} &nbsp;&nbsp;({m.name})
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {searchCollapse && (
            <>
              <Col className="gutter-row" span={12}>
                <Form.Item name={"customerGroupByAge"}>
                  <Select
                    allowClear
                    placeholder="กลุ่มลูกค้าตามระยะเวลา"
                    style={{
                      width: "100%",
                    }}
                    mode={"multiple"}
                    maxTagCount={"responsive"}
                  >
                    <Option key={"all"} value={"all"}>
                      เลือกทั้งหมด
                    </Option>
                    {workPeriod.map((item) => (
                      <Option value={item.dataId}>{item.dataDetailTh}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={12}>
                <Form.Item name={"customerGroupByRegion"}>
                  <Select
                    allowClear
                    placeholder="กลุ่มลูกค้าตามสัญชาติ"
                    style={{
                      width: "100%",
                    }}
                    mode={"multiple"}
                    maxTagCount={"responsive"}
                  >
                    <Option key={"all"} value={"all"}>
                      เลือกทั้งหมด
                    </Option>
                    {regionGroup.map((item) => (
                      <Option value={item.dataId}>{item.dataDetailTh}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={8}>
                <Form.Item
                  label="ตามปริมาณการใช้น้ำต่อเดือน ลูกบาศก์เมตร (ลบ.ม.)"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                  name={"waterConsumptionMin"}
                >
                  <Space>
                    <InputNumber
                      min={0}
                      step="0.01"
                      name="waterConsumptionMin"
                      placeholder="น้อยสุด"
                      style={{ width: 100 }}
                      onChange={(e) => {
                        setWaterConsumption((prev) => ({
                          ...prev,
                          min: e,
                        }));
                      }}
                    />
                    -
                    <InputNumber
                      min={0}
                      step="0.01"
                      name="waterConsumptionMax"
                      placeholder="มากสุด"
                      style={{ width: 100 }}
                      onChange={(e) => {
                        setWaterConsumption((prev) => ({
                          ...prev,
                          max: e,
                        }));
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={9}>
                <Form.Item
                  label="ตามขนาดพื้นที่ที่ประกอบกิจการ (ไร่,งาน,วา)"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                  name={"areaSize"}
                >
                  <Space>
                    <InputNumber
                      name="areaSizeByRaiMin"
                      min={0}
                      step="0.01"
                      placeholder="ไร่"
                      style={{ width: 60 }}
                      onChange={(e) => {
                        setAreaSize((prev) => ({
                          ...prev,
                          raiMin: e,
                        }));
                      }}
                    />
                    <InputNumber
                      name="areaSizeByNganMin"
                      min={0}
                      step="0.01"
                      placeholder="งาน"
                      style={{ width: 60 }}
                      onChange={(e) => {
                        setAreaSize((prev) => ({
                          ...prev,
                          nganMin: e,
                        }));
                      }}
                    />
                    <InputNumber
                      name="areaSizeByWaMin"
                      min={0}
                      step="0.01"
                      placeholder="วา"
                      style={{ width: 60 }}
                      onChange={(e) => {
                        setAreaSize((prev) => ({
                          ...prev,
                          waMin: e,
                        }));
                      }}
                    />
                    -
                    <InputNumber
                      name="areaSizeByRaiMax"
                      min={0}
                      step="0.01"
                      placeholder="ไร่"
                      style={{ width: 60 }}
                      onChange={(e) => {
                        setAreaSize((prev) => ({
                          ...prev,
                          raiMax: e,
                        }));
                      }}
                    />
                    <InputNumber
                      name="areaSizeByNganMax"
                      min={0}
                      step="0.01"
                      placeholder="งาน"
                      style={{ width: 60 }}
                      onChange={(e) => {
                        setAreaSize((prev) => ({
                          ...prev,
                          nganMax: e,
                        }));
                      }}
                    />
                    <InputNumber
                      name="areaSizeByWaMax"
                      min={0}
                      step="0.01"
                      placeholder="วา"
                      style={{ width: 60 }}
                      onChange={(e) => {
                        setAreaSize((prev) => ({
                          ...prev,
                          waMax: e,
                        }));
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={7}>
                <Form.Item
                  label="ตามขนาดพื้นที่ที่ประกอบกิจการ (ตารางเมตร)"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                  name={"areaSizeByMeters"}
                >
                  <Space>
                    <InputNumber
                      name="areaSizeByMetersMin"
                      placeholder="น้อยสุด"
                      min={0}
                      step="0.01"
                      style={{ width: 100 }}
                      onChange={(e) => {
                        setAreaSizeByMeter((prev) => ({
                          ...prev,
                          min: e,
                        }));
                      }}
                    />
                    -
                    <InputNumber
                      name="areaSizeByMetersMax"
                      min={0}
                      step="0.01"
                      placeholder="มากสุด"
                      style={{ width: 100 }}
                      onChange={(e) => {
                        setAreaSizeByMeter((prev) => ({
                          ...prev,
                          max: e,
                        }));
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={8}>
                <Form.Item name="lineOfWork" style={{ marginBottom: 0 }}>
                  <Select
                    allowClear
                    placeholder="สายงาน"
                    mode={"multiple"}
                    maxTagCount={"responsive"}
                  >
                    <Option key={"all"} value={"all"}>
                      เลือกทั้งหมด
                    </Option>
                    {lineOfWork &&
                      lineOfWork.map((e) => (
                        <Option value={e.lineOfWork}>{e.nameTh}</Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </>
          )}

          <Col span={24} align="right">
            <Space>
              <Button onClick={handleCollape}>
                {!searchCollapse ? (
                  <CaretDownFilled style={{ fontSize: 17, color: "#2E90FA" }} />
                ) : (
                  <CaretUpFilled style={{ fontSize: 17, color: "#2E90FA" }} />
                )}
              </Button>
              <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default Search;
